import styled from 'styled-components'

const EmptyState = styled.img`
  object-fit: contain;
  width: 10rem;
  height: 10rem;
`

export default EmptyState